


        <h1>비전/경영이념</h1>
        <div class="vision">
            <img src="/assets/images/vision.png" data-aos="zoom-out-up"
                data-aos-duration="2000">
            <h3>· 비전</h3>
            <em data-aos="fade-up">인간 삶의 편안과 행복 그리고 더 큰 가치를 따라 우리는 영상,
                사물인식, 인공지능의 기술력을 기반으로 사업을 시작하였습니다. 우리의 기술력을 기반으로 자율주행에 필요한 학습데이터 생성
                소프트웨어를 시작으로 사물인식 피킹 로봇에 적용하여 학습된 데이터로 물건을 집고 옮길 수 있도록 하였으며, 현재에는
                인공지능 AR 당구시스템 개발을 진행하고 있습니다. </em> <em data-aos="fade-up">우리의 기술들이
                각기 다른 것으로 생각될 수 있지만, 실상은 우리의 기술력이 다양한 곳에 사용가능하며 활용할 수 있다는 것입니다. 우리의
                핵심기술은 다양한 분야에서 다양한 형태로 우리의 삶에 필요한 어디 곳에든 스며들 수 있습니다. 이렇게 한 발 한 발
                우리가 쓰일 수 있는 곳으로 적극적으로 힘있게 나아가겠습니다. </em>
        </div>
        <div class="philosophy">
            <h3 class="last">· 경영이념</h3>
            <ul>
                <li data-aos="flip-left" data-aos-duration="1000"><img
                    src="/assets/images/philosophy01.png"></li>
                <li data-aos="flip-left" data-aos-duration="1000"><img
                    src="/assets/images/philosophy02.png"></li>
                <li data-aos="flip-left" data-aos-duration="1000"><img
                    src="/assets/images/philosophy03.png"></li>
                <li data-aos="flip-left" data-aos-duration="1000"><img
                    src="/assets/images/philosophy04.png"></li>
            </ul>
            <em data-aos="fade-up">우리는 투명하고도 도덕적인 경영을 바탕으로 구성원들 간의 상호존중을
                추구합니다. <br> 귀중한 구성원들과 함께 끊임없는 노력과 끈기로 기술력의 고도화를 목표로 나아가며, <br>
                이를 통한 우리의 성장은 구성원들과 함께 나누고 지역사회 그리고 나아가 세계와 나누기를 목표하고 있습니다.
            </em>
        </div>
